/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InspectionDataCategoryDto } from '../../models/inspection-data-category-dto';
import { UpdateInspectionDataCategoryDto } from '../../models/update-inspection-data-category-dto';

export interface InspectionDataControllerUpdateCategory$Params {
  id: string;
      body: UpdateInspectionDataCategoryDto
}

export function inspectionDataControllerUpdateCategory(http: HttpClient, rootUrl: string, params: InspectionDataControllerUpdateCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<InspectionDataCategoryDto>> {
  const rb = new RequestBuilder(rootUrl, inspectionDataControllerUpdateCategory.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InspectionDataCategoryDto>;
    })
  );
}

inspectionDataControllerUpdateCategory.PATH = '/api/inspection-data/category/{id}';
